import { createLandingPageRoute } from 'app/track/utils/TrackUtils';

const routes = {
  '/apps/updates': createLandingPageRoute('zb no service', {
    doesRequireServerApp: true,
    isAuthRequired: false,
  }),
  '/apps/updates/:update_id/:update_slug': createLandingPageRoute(
    'zb no service',
    {
      doesRequireServerApp: true,
      isAuthRequired: false,
    }
  ),
};

export default routes;
